import DetailsWrapper from './details-wrapper';

export default DetailsWrapper;
